import type { QuickStepAction } from '../store/schema/QuickStepAction';
import type { QuickStepHotkeyId } from '../store/schema/QuickStepHotkeyId';
import store from '../store/store';

export function getQuickStepActionsByHotkey(hotkey: QuickStepHotkeyId): QuickStepAction[] {
    // This doesn't seem particularly efficient, should I add a map of hotkey to actions?
    const quickStep = store.quickSteps.find(quickStep => quickStep.hotkey === hotkey);
    return quickStep?.actions ?? [];
}
